import { render, staticRenderFns } from "./IndexDev.vue?vue&type=template&id=2ccb7aec&scoped=true&"
import script from "./IndexDev.vue?vue&type=script&lang=js&"
export * from "./IndexDev.vue?vue&type=script&lang=js&"
import style0 from "./IndexDev.vue?vue&type=style&index=0&id=2ccb7aec&scoped=true&lang=css&"
import style1 from "./IndexDev.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb7aec",
  null
  
)

export default component.exports
import {QPageSticky,QTabPanels,QTabPanel,QBtnToggle,QTabs,QTab,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageSticky,QTabPanels,QTabPanel,QBtnToggle,QTabs,QTab,QTable})
